import { Moment } from 'moment'

import { IBlockFormSubmit } from '../../types'
import { IAPICreateBlock } from '../../types/api'

import { blockSpecialDataTransformer } from './blockSpecialDataTransformer'

export const createBlockTransformer = (
  data: IBlockFormSubmit,
): IAPICreateBlock => {
  const repeatStopsAtValue: null | Moment =
    typeof data.repeatStopsAt === 'undefined' ? null : data.repeatStopsAt
  const specialDataTransformer = blockSpecialDataTransformer(
    data.startHour,
    data.endHour,
    data.startsAt,
    data.repeatWeekInterval,
    data.repeatStopsAfter,
    repeatStopsAtValue,
  )

  return {
    blocked_category_uuid: data.blockedCategoryUuid,
    person_uuid: data.personUuid,
    starts_at: specialDataTransformer.startsAt,
    ends_at: specialDataTransformer.endsAt,
    notes: data.notes,
    is_repeat: data.isRepeat,
    repeat_week_interval: data.repeatWeekInterval,
    repeat_stops_at: specialDataTransformer.repeatStopsAt,
  }
}
